export default __webpack_public_path__ + "static/media/forward.4b1847a1.svg";